import { api } from "./axios";

export type PtzCode =
  | "Up" | "Down" | "Left" | "Right"
  | "LeftUp" | "LeftDown" | "RightUp" | "RightDown"
  | "ZoomTele" | "ZoomWide";

export async function ptzControl(
  deviceId: number,
  channel: number,
  body: { action: "start" | "stop"; code: PtzCode; speed?: number },
): Promise<void> {
  await api.post(`/devices/${deviceId}/channels/${channel}/ptz`, body);
}
